import React from "react";
import { useParams } from "react-router-dom";
import { Container } from "reactstrap";
import DeleteModal from "../../../Components/Common/DeleteModal";
import useInvoiceActions from "../hooks/useInvoiceActions";
import FilterBar from "../components/filters/FilterBar";
import InvoiceTable from "../components/table/InvoiceTable";
import PaginationFooter from "../components/table/PaginationFooter";
import EditInvoiceModal from "../components/EditInvoiceModal";
import useVendorDetail from "./hooks/useVendorDetail";
import VendorHeader from "./components/VendorHeader";

const VendorDetail = () => {
  const { cif }    = useParams();
  const decodedCif = decodeURIComponent(cif);

  const detail  = useVendorDetail(decodedCif);
  const actions = useInvoiceActions({ onRefresh: detail.refresh });

  return (
    <div className="page-content">
      <DeleteModal
        show={actions.deleteModal.show}
        onDeleteClick={actions.deleteModal.onConfirm}
        onCloseClick={actions.deleteModal.onCancel}
      />
      <EditInvoiceModal
        {...actions.editModal}
        phases={detail.phases}
        onSaved={detail.refresh}
      />
      <Container fluid>
        <VendorHeader
          vendorName={detail.vendorName}
          cif={decodedCif}
          stats={detail.stats}
        />
        <FilterBar
          count={detail.pagination?.count ?? detail.invoices.length}
          filters={detail.filters}
          phases={detail.phases}
          costTypes={detail.costTypes}
          onChange={detail.setFilters}
          onAdd={null}
        />
        <InvoiceTable
          invoices={detail.invoices}
          loading={detail.loading}
          onEdit={actions.openEdit}
          onDelete={actions.openDelete}
          showVendorLink={false}
        />
        <PaginationFooter
          pagination={detail.pagination}
          currentPage={detail.currentPage}
          loading={detail.loading}
          onNext={() => detail.nextPage(detail.pagination)}
          onPrev={() => detail.prevPage(detail.pagination)}
        />
      </Container>
    </div>
  );
};

export default VendorDetail;
